import React, { useState } from "react";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";

const EditCalendarData = ({ tableRef }) => {
  const { currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const { data, table_id } = currentBlockConfig;
  const [isFieldModalOpen, setIsFieldModalOpen] = useState("");

  const selectFieldCallbackFunction = (data) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data[isFieldModalOpen] = data.id;
    setCurrentBlockConfig(newcalendarConfig);
    setIsFieldModalOpen("");
  };

  const deleteField = (field) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data[field] = "";
    setCurrentBlockConfig(newcalendarConfig);
  };

  const fieldList = [
    { label: "Select Event Title Field", field: "event_title_field" },
    { label: "Select Start Date-Time Field", field: "start_datetime_field" },
    { label: "Select End Date-Time Field", field: "end_datetime_field" },
    { label: "Start Duration Field", field: "duration_field" },
    { label: "Select Start Date Field", field: "start_date_field" },
    { label: "Select End Date Field", field: "end_date_field" },
    { label: "Select Start Time Field", field: "start_time_field" },
    { label: "Select End Time Field", field: "end_time_field" }
    // { label: "Subject Field", field: "subject_field" }
  ];

  return (
    <div className="builder_form p_4" style={{ height: "calc(100vh - 90px)", overflow: "hidden scroll" }}>
      {fieldList.map(({ label, field }) => (
        <React.Fragment key={field}>
          <div className="builder_form ">
            <label className="builder_label">{label}</label>
            <div className="d_flex g_8">
              <div className="builder_input w_100" onClick={() => setIsFieldModalOpen(field)}>
                {tableRef.current[data[field]]?.display || "Select field"}
              </div>
              {tableRef.current[data[field]]?.display && (
                <ButtonActionIcon size="xsm" type="delete" onClick={() => deleteField(field)} />
              )}
            </div>
          </div>
        </React.Fragment>
      ))}
      <BuilderModal isOpen={isFieldModalOpen} onClose={() => setIsFieldModalOpen("")} modalName="Select Field">
        <TableTreeModal
          callbackFunction={selectFieldCallbackFunction}
          tableId={table_id}
          selectedFile={data?.[isFieldModalOpen] || ""}
        />
      </BuilderModal>
    </div>
  );
};

export default EditCalendarData;
